export default __webpack_public_path__ + "assets/icon1-d4ca12c.svg";